import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText } from '../../../packages/kiti/components/presentation/Text'
import { Title } from '../../../components/presentation/Text'
import { useForm } from './_load/FormLoader'

const ModalHeader = () => {
  const { t } = useTranslation('listForms')
  const form = useForm()
  return (
    <>
      <SmallText align="center">{t('sendHistory')}</SmallText>
      <Title size="h4" align="center">
        {form?.name}
      </Title>
    </>
  )
}

export default ModalHeader
